const SubtypeConnector = ' > '

export enum FADashboardType {
  Risk = 'Risk',
  Attribution = 'Attribution'
}

export enum FADashboardSubtype {
  Risk = 'Risk',
  FactorAttribution = 'Factor Attribution',
  BrinsonAttribution = 'Brinson Attribution'
}

/** Enum representing a Type + Subtype combination. */
export enum FADashboardFullType {
  Risk_Risk = "Risk > Risk",
  Attribution_FactorAttribution = "Attribution > Factor Attribution",
  Attribution_BrinsonAttribution = "Attribution > Brinson Attribution",
};

/** Dictionary of types to a list of their subtypes. */
const FADashboardTypeMapping: Record<FADashboardType, FADashboardSubtype[]> = {
  [FADashboardType.Risk]: [FADashboardSubtype.Risk],
  [FADashboardType.Attribution]: [FADashboardSubtype.FactorAttribution, FADashboardSubtype.BrinsonAttribution]
}
